/**
 * PostHog runs whenever a project token is configured.
 */
export const POSTHOG_ENABLED = Boolean(import.meta.env.VITE_POSTHOG_PROJECT_TOKEN);
